import { createCheckboxUI } from './checkboxUI';
import { CheckboxUI } from './checkboxUI';

export class Checkbox {

  public onChange: () => void = () => { };
  //public onChange: () => void;

  public constructor(public ui: CheckboxUI) {
    this.ui.render().then(data => {
      this.afterRender();
    });
  }

  public changeHandler() {
    this.onChange();
  }

  private afterRender() {
    this.ui.listen(this.changeHandler.bind(this));
  }

  public setActive(triggerChange: boolean = false) {
    this.ui.setActive();
    if (triggerChange) {
      this.changeHandler();
    }
  }

  public setInactive(triggerChange: boolean = false) {
    this.ui.setInactive();
    if (triggerChange) {
      this.changeHandler();
    }
  }

  public toggle(triggerChange: boolean = false) {
    this.ui.toggle(this.onChange.bind(this));
    if (triggerChange) {
      this.changeHandler();
    }
  }
}

/**
 * Initialize the checkbox component
 */
export function initCheckbox(extend: boolean = false) {
  return createCheckboxUI(extend).map((element) => {
    const ui: CheckboxUI = element;
    if (extend) {
      window.checkboxes.push(new Checkbox(ui));
    } else {
      return new Checkbox(ui);
    }
  });
}
